<template>
    <div class="card"  style="height: 100%">
        <div class="card-header d-flex justify-content-between">
            <div class="">Geo Map</div>
            <a v-on:click="commentBox(codropdown)" class="txt-color-white right-padding-50">
                <i class="fa fa-lg fa-comments"></i>
            </a>
        </div>


        <div class="card-body">
            <p v-if="loading">Loading...</p>
            <div id="mapContainer" style="width: 90%"></div>
        </div>

        <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
            <b-form-group label="Comment">
                <textarea rows="3" cols="40" v-model="cmnt"
                          placeholder="Write a comment..."></textarea>
            </b-form-group>
        </b-modal>
        <!--
         I also added a simple loading indicator,
         obviously you can go for something more fancy like a spinner
        -->

        <!--<div id="mapContainer">{{ latlng }}</div>-->
    </div>
</template>

<script>
import L, {Icon} from "leaflet";
import "leaflet/dist/leaflet.css";

import axios from 'axios';

// this part resolve an issue where the markers would not appear
     delete Icon.Default.prototype._getIconUrl;

    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png')
    });

    export default {
        name: "Map",
        data() {
            return {
                mymap: null,
                loading: false,
                // latlng: [],
                showModal: false,
                cmnt: "",
                annotations: [],
                annotationTitle: '',
                // icon: L.icon({
                //     iconUrl: require("leaflet/dist/images/marker-icon.png"),
                //     iconSize: [38, 95],
                //     iconAnchor: [22, 94]
                // })
            };
        },
        methods: {
            setupLeafletMap: function () {

                /* Default map */
             /*  this.mymap = L.map('mapContainer').setView([20.5937, 78.9629], 4);*/
               this.mymap = L.map('mapContainer').setView([44.82, -93.58], 6);


                /*Adding a tile from mapbox with the zoom level */
                L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    maxZoom: 18,
                    id: 'mapbox/streets-v11',
                    tileSize: 512,
                    zoomOffset: -1,
                    accessToken: 'pk.eyJ1IjoibXVpbnNoYXJpZmYiLCJhIjoiY2tmMTlsbnRzMTI2ZTJzcGhiemt6d2Z2MiJ9.-apvKqeNTsJ5jJ7Sm1MkTg'
                }).addTo(this.mymap);
            }
        },
        mounted() {

            this.loading = true;


           /* axios({ url: '/json/fdc.json', baseURL: '', method: 'GET' }).then(res => {*/

          var url = '/api/fetchDataWithParam/SQL776/Any'
          axios.post(url,{}).then(res=>{

            /*console.log('stringify:',JSON.stringify(convertedStr3,/\\/g,''))*/
            var lstr = res.data.rowsData[0].incident_stats.value.replaceAll('\\', '')
            //console.log('spider-man',lstr)
            //var json = res.data.rowsData[0]
            var doublejson = JSON.parse(lstr)

            //console.log('lkdljjdljdljdlj',doublejson)
            /*console.log('lstr********',lstr)*/
            /*console.log('lstrconvertedobject',JSON.stringify(JSON.parse(lstr)))*/
            /*var clstr=JSON.parse(lstr)*/
            /*console.log ('parsedJson',clstr)*/

            var geojson = L.geoJson(doublejson, {
              onEachFeature: function(feature, layer) {
                /*layer.bindPopup( '<p><b>Revenue : </b>'+feature.properties.revenue+'</p><p><b>Year Month : </b>'+feature.properties.year_month+'</p><p><b>Salesman_Name : </b>'+feature.properties.salesman_name+'</p><p><b>Salesman_Id : </b>'+feature.properties.salesman_id+'</p><p><b>Retailer_Name : </b>'+feature.properties.retailer_name+'</p><p><b>Retailer_Id : </b>'+feature.properties.retailer_id+'</p><p><b>City : </b>'+feature.properties.city+'</p><p><b>State : </b>'+feature.properties.state+'</p><p><b>Country : </b>'+feature.properties.country+'</p>');
             */
                /*layer.bindPopup( '<p><b>crash_date :  </b>'+feature.properties.crash_date+'</p><p><b>posted_speed_limit :  </b>'+feature.properties.posted_speed_limit+'</p><p><b>traffic_control_device :  </b>'+feature.properties.traffic_control_device+'</p><p><b>device_condition :  </b>'+feature.properties.device_condition+'</p><p><b>weather_condition :  </b>'+feature.properties.weather_condition+'</p><p><b>lighting_condition :  </b>'+feature.properties.lighting_condition+'</p><p><b>first_crash_type :  </b>'+feature.properties.first_crash_type+'</p><p><b>trafficway_type :  </b>'+feature.properties.trafficway_type+'</p><p><b>alignment :  </b>'+feature.properties.alignment+'</p><p><b>roadway_surface_cond :  </b>'+feature.properties.roadway_surface_cond+'</p><p><b>road_defect :  </b>'+feature.properties.road_defect+'</p><p><b>report_type :  </b>'+feature.properties.report_type+'</p><p><b>crash_type :  </b>'+feature.properties.crash_type+'</p><p><b>intersection_related_i :  </b>'+feature.properties.intersection_related_i+'</p><p><b>not_right_of_way_i :  </b>'+feature.properties.not_right_of_way_i+'</p><p><b>hit_and_run_i :  </b>'+feature.properties.hit_and_run_i+'</p><p><b>damage :  </b>'+feature.properties.damage+'</p>');
            */layer.bindPopup( '<p><b>street_direction :  </b>'+feature.properties.street_direction+
                    '</p><p><b>street_name :  </b>'+feature.properties.street_name+
                    '</p><p><b>beat_of_occurrence :  </b>'+feature.properties.beat_of_occurrence+
                   /* '</p><p><b>photos_taken_i :  </b>'+feature.properties.photos_taken_i+
                    '</p><p><b>statements_taken_i :  </b>'+feature.properties.statements_taken_i+*/
                   /* '</p><p><b>dooring_i :  </b>'+feature.properties.dooring_i+
                    '</p><p><b>work_zone_i :  </b>'+feature.properties.work_zone_i+
                    '</p><p><b>work_zone_type :  </b>'+feature.properties.work_zone_type+
                    '</p><p><b>workers_present_i :  </b>'+feature.properties.workers_present_i+*/
                    '</p><p><b>num_units :  </b>'+feature.properties.num_units+
                    '</p><p><b>most_severe_injury :  </b>'+feature.properties.most_severe_injury+
                    '</p><p><b>injuries_total :  </b>'+feature.properties.injuries_total+
                    '</p><p><b>injuries_fatal :  </b>'+feature.properties.injuries_fatal+
                    '</p><p><b>injuries_incapacitating :  </b>'+feature.properties.injuries_incapacitating+
                    '</p><p><b>injuries_non_incapacitating :  </b>'+feature.properties.injuries_non_incapacitating+
                    '</p><p><b>injuries_reported_not_evident :  </b>'+feature.properties.injuries_reported_not_evident+
                    '</p><p><b>injuries_no_indication :  </b>'+feature.properties.injuries_no_indication+'</p>'+
                    '</p><p><b>injuries_unknown :  </b>'+feature.properties.injuries_unknown+'</p>'+
                    '</p><p><b>crash_hour :  </b>'+feature.properties.crash_hour+'</p>'+
                    '</p><p><b>crash_day_of_week :  </b>'+feature.properties.crash_day_of_week+'</p>'+
                    '</p><p><b>crash_month :  </b>'+feature.properties.crash_month+'</p>'+
                    '</p><p><b>highway_name :  </b>'+feature.properties.highway_name+'</p>' //+
                    /*'</p><p><b>date_police_notified :  </b>'+feature.properties.date_police_notified+'</p>'*/);
              }
            });
            /*console.log("Json Parse ",res.data.rowsData[0]);*/
           // console.log("Geo Json Output",geojson);
            this.setupLeafletMap();


            geojson.addTo(this.mymap);
            // Creating the Map here ensures that data is already loaded from server side

            this.loading = false;
          }).catch(error => console.error(error));
         /* axios({ url: '/json/incident_reportbkp.json', baseURL: '', method: 'GET' }).then(res => {

            var str = JSON.stringify(res.data);
            console.log('spider-man',str)

            // Remove \ from the string
            var convertedStr= str.replace(/\\/g,'');
            console.log('spider-man-2',convertedStr)

              // Convert updated string back to object
            var newObj = JSON.parse(convertedStr);
                // L.geoJson function is used to parse geojson file and load on to map
            console.log('spider-man-3',newObj)

          /!*  var geojson = L.geoJson(res.data, {*!/
            var geojson = L.geoJson(newObj, {
                    onEachFeature: function(feature, layer) {
                        /!*layer.bindPopup( '<p><b>Revenue : </b>'+feature.properties.revenue+'</p><p><b>Year Month : </b>'+feature.properties.year_month+'</p><p><b>Salesman_Name : </b>'+feature.properties.salesman_name+'</p><p><b>Salesman_Id : </b>'+feature.properties.salesman_id+'</p><p><b>Retailer_Name : </b>'+feature.properties.retailer_name+'</p><p><b>Retailer_Id : </b>'+feature.properties.retailer_id+'</p><p><b>City : </b>'+feature.properties.city+'</p><p><b>State : </b>'+feature.properties.state+'</p><p><b>Country : </b>'+feature.properties.country+'</p>');
                     *!/
                      layer.bindPopup( '<p><b>crash_date :  </b>'+feature.properties.crash_date+'</p><p><b>posted_speed_limit :  </b>'+feature.properties.posted_speed_limit+'</p><p><b>traffic_control_device :  </b>'+feature.properties.traffic_control_device+'</p><p><b>device_condition :  </b>'+feature.properties.device_condition+'</p><p><b>weather_condition :  </b>'+feature.properties.weather_condition+'</p><p><b>lighting_condition :  </b>'+feature.properties.lighting_condition+'</p><p><b>first_crash_type :  </b>'+feature.properties.first_crash_type+'</p><p><b>trafficway_type :  </b>'+feature.properties.trafficway_type+'</p><p><b>alignment :  </b>'+feature.properties.alignment+'</p><p><b>roadway_surface_cond :  </b>'+feature.properties.roadway_surface_cond+'</p><p><b>road_defect :  </b>'+feature.properties.road_defect+'</p><p><b>report_type :  </b>'+feature.properties.report_type+'</p><p><b>crash_type :  </b>'+feature.properties.crash_type+'</p><p><b>intersection_related_i :  </b>'+feature.properties.intersection_related_i+'</p><p><b>not_right_of_way_i :  </b>'+feature.properties.not_right_of_way_i+'</p><p><b>hit_and_run_i :  </b>'+feature.properties.hit_and_run_i+'</p><p><b>damage :  </b>'+feature.properties.damage+'</p>');
                    }
                });
                console.log("Geo JAson Output",res.data);
                console.log("Geo JAson Output",geojson);
                this.setupLeafletMap();


                geojson.addTo(this.mymap);
                 // Creating the Map here ensures that data is already loaded from server side

                this.loading = false;

            }).catch(error => console.error(error));*/
        },
        beforeDestroy() {
            if (this.mymap) {
                this.mymap.remove();
            }
        }
    };
</script>

<style scoped>
    #mapContainer {
        width: 10vw;
        height: 100vh;
    }
</style>